import ApiService from '../api.service'
import getCurrentCompanyId from '../company.service'

export interface IClassificationType {
  id: number
  name: string
  nature?: string | null
  nature_label?: string | null
}

export interface IClassificationTypeGroupSensor {
  id: number
  name: string
  sensor_type?: string
  has_open_alarm?: boolean
}

export interface IClassificationTypeGroup {
  id: number
  name: string
  classification_types: IClassificationType[]
  sensors: IClassificationTypeGroupSensor[]
  groups: { id: number; name: string }[]
}

const ClassificationTypeResource = {
  getTypes: () =>
    ApiService.get(`/v1/companies/${getCurrentCompanyId()}/classification_types`) as Promise<IClassificationType[]>,

  createType: (params: { name: string; nature?: string | null }) =>
    ApiService.post(`/v1/companies/${getCurrentCompanyId()}/classification_types`, params),

  updateType: (id: number, params: { name: string; nature?: string | null }) =>
    ApiService.put(`/v1/companies/${getCurrentCompanyId()}/classification_types/${id}`, params),

  deleteType: (id: number) =>
    ApiService.delete(`/v1/companies/${getCurrentCompanyId()}/classification_types/${id}`),

  getGroups: () =>
    ApiService.get(`/v1/companies/${getCurrentCompanyId()}/classification_type_groups`) as Promise<IClassificationTypeGroup[]>,

  getGroup: (id: number) =>
    ApiService.get(`/v1/companies/${getCurrentCompanyId()}/classification_type_groups/${id}`) as Promise<IClassificationTypeGroup>,

  createGroup: (params: { name: string; classification_type_ids?: number[]; sensor_ids?: number[]; group_ids?: number[] }) =>
    ApiService.post(`/v1/companies/${getCurrentCompanyId()}/classification_type_groups`, params),

  updateGroup: (
    id: number,
    params: { name: string; classification_type_ids?: number[]; sensor_ids?: number[]; group_ids?: number[] },
  ) => ApiService.put(`/v1/companies/${getCurrentCompanyId()}/classification_type_groups/${id}`, params),

  deleteGroup: (id: number) =>
    ApiService.delete(`/v1/companies/${getCurrentCompanyId()}/classification_type_groups/${id}`),
}

export default ClassificationTypeResource
